<div id="doctors-list" class="flex flex-col gap-3">
  <div>
    <a class="cursor-pointer flex flex-row" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      <p>Back</p>
    </a>
  </div>
  @if (patient) {
    <div class="card flex p-5 flex-col justify-between">
      <div class="flex flex-row justify-between flex-wrap">
        <div class="details flex flex-col gap-2">
          <h1>Patient Details</h1>
          <div class="flex justify-between">
            <p>Name & Surname:</p>
            <p>{{ patient.first_name }} {{ patient.last_name }}</p>
          </div>
          <div class="flex justify-between">
            <p>E-mail Address:</p>
            <p>{{ patient.email }}</p>
          </div>
          <div class="flex justify-between">
            <p>Phone Number:</p>
            <p>{{ patient.phone }}</p>
          </div>
          <div class="flex justify-between">
            <p>Doctor's Name:</p>
            <p>{{ doctor?.first_name }} {{ doctor?.last_name }}</p>
          </div>
        </div>
        <div>
          <img src="assets/avatars/1.svg" alt="doctor" class="rounded-full h-60 w-60">
        </div>
      </div>
      <div class="flex flex-row flex-wrap justify-between w-full">
        <div class="patient-block" (click)="openReports()">
          <div class="flex flex-col justify-center h-full">
            <img src="assets/icons/circle_chart.png" width="50px">
            <p>Report Dashboard</p>
          </div>
        </div>
        <div class="patient-block" (click)="openKits()">
          <div class="flex flex-col justify-center h-full">
            <div class="h-12 w-12">
              <mat-icon fontIcon="science" style="font-size: 50px; width: 50px; height: 50px"></mat-icon>
            </div>
            <p>Registered Kits</p>
          </div>
        </div>
        <!--        <div class="patient-block">-->
        <!--          <div class="flex flex-col justify-center h-full">-->
        <!--            <img src="assets/icons/circle_chart.png" width="50px">-->
        <!--            <p>Report Dashboard</p>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="patient-block">-->
        <!--          <div class="flex flex-col justify-center h-full">-->
        <!--            <img src="assets/icons/circle_chart.png" width="50px">-->
        <!--            <p>Report Dashboard</p>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>
  } @else {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
</div>
